import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Input, CheckInput } from "../../../../../common/Input";
import { Select } from "../../../../../common/Select";
import { FEATURES } from "../../../../../config/features";
import { DivisionPickerSelect } from "../../../../../common/selectComponents/DivisionPicker";

const DepartmentAddEditModal = ({ isOpen, onClose, selectedItem, onSave, divisionOptions }) => {
  const [form, setForm] = useState({
    code: "",
    description: "",
    divisionId: null,
    isActive: true,
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (selectedItem) {
      setForm({
        code: selectedItem.code || "",
        description: selectedItem.description || "",
        divisionId: selectedItem.divisionId || null,
        isActive: selectedItem.isActive ?? true,
      });
    } else {
      setForm({ code: "", description: "", divisionId: null, isActive: true });
    }
    setErrors({});
  }, [selectedItem, isOpen]);

  const validate = () => {
    let newErrors = {};
    if (FEATURES.DEPARTMENT_CODE && !form.code) newErrors.code = true;
    if (!form.description) newErrors.description = true;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3">
      <div className="bg-white w-full md:w-[500px] rounded-lg shadow-xl flex flex-col">
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h2 className="text-xl font-bold">{selectedItem ? "Edit" : "Add"} Department</h2>
          <button onClick={onClose} className="bg-transparent border-none cursor-pointer"><CloseIcon /></button>
        </div>

        <div className="p-6 space-y-4">
          <DivisionPickerSelect
            label="Division"
            value={form.divisionId}
            onSelect={(val) => setForm({ ...form, divisionId: val.id })}
            placeholder="--Select Division--"
            allowAll={false}
          />

          {FEATURES.DEPARTMENT_CODE && (
            <Input
              label="Code"
              placeholder="Enter code"
              value={form.code}
              onChange={(e) => setForm({ ...form, code: e.target.value })}
              isRequired
              error={errors.code}
            />
          )}

          <Input
            label="Description"
            placeholder="Enter description"
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
            isRequired
            error={errors.description}
          />

          <CheckInput
            name="Active"
            value={form.isActive}
            onChange={(val) => setForm({ ...form, isActive: val })}
            isEditMode={true}
          />
        </div>

        <div className="flex justify-end space-x-2 p-5 border-t">
          <button onClick={onClose} className="px-4 py-2 bg-gray-200 rounded border-none cursor-pointer">Cancel</button>
          <button
            onClick={() => validate() && onSave(form)}
            className="px-6 py-2 rounded border-none cursor-pointer text-white bg-blue-600"
          >
            {selectedItem ? "Update" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DepartmentAddEditModal;